<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-card class="rounded-xl" max-width="400">
        <v-card-title class="headline d-flex justify-center">
          Ваш e-mail подтверждён!
        </v-card-title>

        <v-card-actions class="d-flex justify-center">
          <v-btn
            color="green lighten-1"
            class="text-none headline"
            text
            to="/login"
          >
            Войти
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>


<script>
import auth from "../config/auth";

export default {
  data: () => ({
    // url: "http://127.0.0.1:8000/api/signup/",
    url: "/auth/users/activation/",
  }),

  methods: {
    postData: function (uid, token) {
      // console.log("email:" + this.email);
      auth
        .post(this.url, { uid: uid, token: token })
        .then((response) => {
          response;
          // console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  beforeMount() {
    let uid = this.$route.params.uid;
    let token = this.$route.params.token;
    this.postData(uid, token);
  },
};
</script>
